<footer class="legal-footer">
  <div class="container d-flex flex-column flex-md-row justify-content-between align-items-center py-2">
    <div class="legal-footer-links">
      <a routerLink="/mentions-legales">Mentions légales</a>
      <span class="separator">·</span>
      <a routerLink="/policy">Confidentialité</a>
      <span class="separator">·</span>
      <a routerLink="/cgu">CGU</a>
      <span class="separator">·</span>
      <a routerLink="/cgv">CGV</a>
      <span class="separator">·</span>
      <a routerLink="/cookies">Cookies</a>
      <span class="separator">·</span>
      <a href="javascript:void(0)" (click)="ouvrirBandeauCookies()">Gérer les cookies</a>
    </div>
    <div class="legal-footer-copyright">© {{ currentYear }} {{ config.appName }}</div>
  </div>
</footer>
